import { useMemo } from 'react';
import { useEventNotifications } from './useEventNotifications';
import { isMeetingNotification } from '../../filters/notifications/isMeetingNotification';

export function useMeetingNotifications(eventId, meetingId, { filter }) {
    const notifications = useEventNotifications(eventId, {
        filter: isMeetingNotification,
    });

    return useMemo(() => {
        let result = notifications.filter(
            (notif) => notif.content?.data?.meetingId == meetingId
        );
        if (filter) result = result.filter(filter);
        return result;
    }, []);
}
